module.exports = __webpack_public_path__ + "media/icons/right-arrow-white-a69ab610.png";